export const DOCUMENTS_ROUTE_SEGMENTS = {
  root: "documents",
} as const;

export const DOCUMENTS_PATH = `/${DOCUMENTS_ROUTE_SEGMENTS.root}`;
